export interface Params {
  count?: number;
  context?: any;
}

export const mockTFunction = (t: string, params: Params = {}) => {
  const { context, count, ...rest } = params;
  let key = t;

  if (typeof params !== 'string') {
    if (context) {
      key += `_${context}`;
    }

    if (count === 1) {
      key += '_one';
    } else if (count !== undefined) {
      key += '_other';
    }

    const paramsStr =
      Object.keys(rest).length > 0 ? `(${JSON.stringify(rest)})` : '';
    return `${key}${paramsStr}`;
  } else {
    return `${key}("${params}")`;
  }
};

export const mockUseTranslation = () => {
  return {
    t: mockTFunction,
    i18n: {
      language: 'en',
      resolvedLanguage: 'en',
    },
  };
};
